<p class="debugMessage"><small>Account-Manage-features:</small></p>
<nav class="navbar navbar-expand-lg bg-body-tertiary alignRow" style="height: var(--navBar-Height);">
    <span style="font-weight: bold;">Account Features</span>
    <span class="navbar-nav me-auto mb-2 mb-lg-0"></span>
</nav>
<div class="main-features-div">
    <div class="account-features" *ngIf="selectedAccount && allFeatures.length > 0">
        <div class="feature-headings" >
            <span>Feature Name</span>
            <span>Feature Description</span>
            <span style="margin: auto;">Account Has Feature</span>
            <span style="margin: auto;">Feature Enabled</span>
        </div>
        <hr>
        <div class="feature-list">
            <div class="feature-item alignRow" *ngFor="let accountFeature of accountFeatures, index as i">
                <span>{{ accountFeature.Feature.FeatureName }}</span>
                <span>{{ accountFeature.Feature.FeatureDescription }}</span>
                <mat-checkbox color="primary" style="margin: auto;" [checked]="accountFeature.Has"
                    (change)="updateValue($event, accountFeature.Feature.FeatureID, true)"
                    [disabled]="i==0"></mat-checkbox>
                <mat-checkbox color="primary" style="margin: auto;" [checked]="accountFeature.Enabled"
                    (change)="updateValue($event, accountFeature.Feature.FeatureID, false)"
                    [disabled]="i==0 || !accountFeature.Has"></mat-checkbox>
            </div>
        </div>
    </div>
    <div class="submit-button alignColumn">
        <button mat-raised-button (click)="patchAccountFeatures(selectedAccount)" [disabled]="!featuresChanged || !currentUser.AdminSite">
            <mat-icon>done</mat-icon>
            <span>Update Features</span>
        </button>
    </div>
</div>